import { Injectable, signal } from '@angular/core';

import { ConfigurationState } from '@cubigo/digital-signage';

@Injectable({ providedIn: 'root' })
export class ConfigDataService {
  /** Published once the display configuration lands; read by the header interceptor and the i18n loader. */
  public readonly configuration = signal<ConfigurationState | null>(null);
}
